<template>
  <v-container>
    <PaymentCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadTaxPayments"
      :postPayment="postPayment"
      :preErrorCheckPayments="preErrorCheckPayments"
      ref="paymentCriteria"
    />
    <PayrixPaymentDialog
      v-if="isPayrixDialogOpen"
      :fieldNameLists="fieldNameListsForPayrixDialog"
    />
    <Forte2PaymentDialog
      v-if="isForte2DialogOpen"
      :fieldNameLists="fieldNameListsForForte2Dialog"
    />
    <template>
      <v-row>
        <v-col cols="10">
          <CRUDList
            ref="crudList"
            :canAdd="false"
            :headers="headers"
            :displayTopPagination="false"
            :canEdit="true"
            :canSave="false"
            :canCancel="false"
            :showDate="true"
            :showTotal="true"
            :enableFixedHeaders="true"
            :removeHighlightOnDoubleClick="false"
            :baseCrudKey="baseCrudKey"
            :defaultSortBy="defaultSortBy"
            :uploadFileParams="uploadFileParams"
            :variableToChangeRowBgColor="[{ varName: 'overUnderStatus', varCol: '#82B1FF' },
            { varName: 'misMatchFlag', varCol: '#ff5252' },
            { varName: 'everyTransVoided', varCol: '#ffd180' }]"
            tableWrapperDynamicClassname="elevation-3 ma-3 pa-3 taxroll-table-wrapper"
            tableDynamicClassname="taxroll-custom-table"
            tableDynamicHeight="250"
            @activateItem="activateTransaction"
            @loadCRUDList="handleLoadTaxPayments"
            @upsertItem="guardedPreUpsert"
            @onDoubleClicked="onDoubleClicked"
            @onSingleClicked="handleSingleOrArrowClick"
            @onArrowUpOrDown="handleSingleOrArrowClick"
            @crudDialogEnter="guardedPreUpsert"
            :loadingData="gridLoading.flag"
            :loadingText="gridLoading.text"
            >
            <template v-slot:[`editedItem`]="{}">
              <paymentDialog
              ref="paymentDialogRef"
              :baseCrudKey="baseCrudKey"
              @callFromPayDialog="onSaveClick"
              />
            </template>
             <template v-slot:[`additionalActionsAfterSave`]="{}">
              <v-btn class="input-text-size" text color="blue darken-1"
              @click="crudDialogClose">Close</v-btn>
              <v-btn class="input-text-size payment-transaction-list-save-btn"
              id="paymentTransactionListSaveBtn"
              text color="blue darken-1"
              @click="onSaveClick(false)" :disabled="isSaveBlocked">Save</v-btn>
              <v-btn class="input-text-size payment-transaction-list-save-print-btn"
              id="paymentTransactionListSavePrintBtn"
              text color="blue darken-1"
              @click="onSaveClick(true)" :disabled="isSaveBlocked">Save & print</v-btn>
             </template>
            <template v-slot:[`additionalActions`]="{}">
              <v-btn class="input-text-size" text color="blue darken-1"
              @click="taxPaymentReceipt" :disabled="checkccProcessed">Credit Card Receipt</v-btn>
                <UploadFile
                    class="mtgtrans uploadFile"
                    text
                    :bucketName="attachmentConstants.bucketName"
                    :program="attachmentConstants.program"
                    :parentObjectType="attachmentConstants.parentObjectType"
                    :parentObjectId="getActiveTransID || ''"
                    :itemIsSaved="!isNewItem"
                  >
                        <template v-slot:activator="{ activatorProps }">
                          <v-btn
                            :disabled="enableUploadFile"
                            class="input-text-size payment-transaction-list-upload-btn"
                            id="paymentTransactionListUploadBtn"
                            text
                            color="blue darken-1"
                            @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
                            @click="imagesLeftClick(activatorProps.leftClick)"
                          >
                            {{ activatorProps.caption }}
                          </v-btn>
                        </template>
                      </UploadFile>
                  <AuditDialog
                  v-if="getActiveTransID"
                  :identifier="getActiveTransID"
                  activatorCaption="Audit History"
                  activatorCaptionStyle = "input-text-size"
                />
            </template>
      <template v-slot:addidtionalCrudFooter>
        <tr style="width: 100%; display: inline-table;">
          <td width="10%"></td>
          <td width="20%"><h5 class="input-text-size align-right">Totals</h5></td>
          <td width="22%"><h5 class="input-text-size align-right">{{totals.total}}</h5></td>
          <td width="15%"><h5 class="input-text-size align-right">{{totals.checkAmt}}</h5></td>
          <td width="16%"><h5 class="input-text-size align-right">{{totals.cashAmt}}</h5></td>
          <td width="13%"><h5 class="input-text-size align-right">{{totals.changeAmt}}</h5></td>
          <td width="20%"><h5 class="mr-n16
            input-text-size align-right">{{totals.otherAmt}}</h5></td>
        </tr>
      </template>
          </CRUDList>
        </v-col>
        <v-col cols="2" class="custom-margin">
          <PaymentButtons
            @handlePrePaymentDialog="handlePrePaymentDialog"
            @callBackForUpsert="guardedPreUpsert"
            ref="payButtons"
            :handleLoadTaxPayments="handleLoadTaxPayments"
            :activeTransItem="activeTransItem"
            />
        </v-col>
      </v-row>
    </template>

    <v-alert
      v-if="showLargeTransactionWarning"
      type="warning"
      dense
      dismissible
      @input="showLargeTransactionWarning = false"
      class="ma-3"
    >
      Unable to load transaction details on screen due to large number of transactions (over 100).
    </v-alert>

    <PaymentDetailsTransactionList v-if="!showLargeTransactionWarning"
      class="mt-n9"
      @handleDialogItem="handleDialogItem"
      :baseCrudKey="baseCrudKeyForTax"
      :paymentBaseCrudKey="baseCrudKey"
    />

    <CRUDDialog baseCrudKey="paymentAuditRecord" :canCancel="false"
      @upsertItem="upsertAuditTransaction">
      <template v-slot:[`editedItem`]="{}">
        <auditRecord baseCrudKey="paymentAuditRecord" />
      </template>
    </CRUDDialog>
    <CRUDDialog baseCrudKey="paymentAuditRecordForVoid" :canCancel="false"
      @upsertItem="upsertAuditTransactionForVoids">
      <template v-slot:[`editedItem`]="{}">
        <auditRecord baseCrudKey="paymentAuditRecordForVoid" />
      </template>
    </CRUDDialog>
    <CRUDDialog dialogDynamicWidth="70vw" :canSave="false"
      baseCrudKey="ComhDecalmmonDecalDialogCrudKey" >
      <template v-slot:[`editedItem`]="{}">
        <CommonDecalDialog />
      </template>
      <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="upsertCommonDecalDialogCrudKey">Save</v-btn>
      </template>
    </CRUDDialog>
    <CommonPopUp v-model="popUpMtgCodeRemoveOrNot" v-if="popUpMtgCodeRemoveOrNot"
    :enableFlashTypeMsg="false">
      <template v-slot:customsLabelOrInfo>
        <span class="elevation-1"><br/>
        <p style="white-space: pre;">
          <v-icon class="ChangeIconRedColor">
            {{ icons.mdiCircleSlice8 }}
          </v-icon> {{ getMtgCodesMsg() }}
        </p>
      </span>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="openPopUpForMtgCodeRemoveOrNot('Remove')">Remove</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="openPopUpForMtgCodeRemoveOrNot('Close')">Close</v-btn>
      </template>
    </CommonPopUp>
    <CommonPopUp v-model="showOrHideLatestPostDate" v-if="showOrHideLatestPostDate"
        :enableFlashTypeMsg="true" flashType="warning">
        <template v-slot:customsLabelOrInfo>
          <p class="mt-3">Payments have been posted through {{ paymentSettingItem.latestPostDate }}.
            Are you sure you wish to create a payment transaction on {{ effectiveBusinessDate }}
          </p>
        </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn class="input-text-size payment-transaction-list-continue-btn"
          id="paymentTransactionListContinueBtn"
           text color="blue darken-1"
          @click="openConfirmPopUp('Continue')">Continue</v-btn>
          <v-btn class="input-text-size payment-transaction-list-cancel-btn"
          id="paymentTransactionListCancelBtn"
          text color="blue darken-1"
          @click="openConfirmPopUp('Cancel')">Cancel</v-btn>
        </template>
      </CommonPopUp>
      <CommonPopUp v-model="showOrHideWkstErrorMsg" v-if="showOrHideWkstErrorMsg"
      :enableFlashTypeMsg="true" flashType="warning">
        <template v-slot:customsLabelOrInfo>
          <p class="mt-3">Must select a single workstation number to override the
            default workstation</p>
        </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn class="input-text-size" text color="blue darken-1"
          @click="openConfirmWkstErrorPopUp('OK')">OK</v-btn>
        </template>
    </CommonPopUp>
      <CommonPopUp v-model="showOrHideFutureBusinessDate" v-if="showOrHideFutureBusinessDate"
      :enableFlashTypeMsg="true" flashType="warning">
        <template v-slot:customsLabelOrInfo>
          <p v-if="businessDateBlockMsg" class="mt-3">{{ businessDateBlockMsg }}</p>
          <p v-else class="mt-3">The business date {{ effectiveBusinessDate }} is outside the current
            posting period. Check the business date and try again.</p>
        </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn class="input-text-size" text color="blue darken-1"
          @click="showOrHideFutureBusinessDate = false">OK</v-btn>
        </template>
    </CommonPopUp>
  </v-container>
</template>

<script>
import router from '@/router';
import {
  mdiCircleSlice8,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import {
  getBusinessDateForPaymentEntry, isFiscalYearWithinPostingPeriod, toFiscalYear,
  toFiscalYearDateRange, toIsoDate, toShortDate,
} from '../../../util/shared/tmc-global';
import AuditDialog from '../../common/audit/AuditDialog.vue';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import PaymentCommonFunc from '../common-utils/PaymentCommonFunc.mixin';
import auditRecord from './audit/auditRecord.vue';
import PaymentButtons from './paymentButtons.vue';
import PaymentCriteria from './paymentCriteria.vue';
import PaymentDetailsTransactionList from './paymentDetailsTransactionList.vue';
import paymentDialog from './paymenteditDialog/paymentDialog.vue';
import { paymentTransactionListHeaders } from './paymentutils/PaymentTransactionTableHeaders';

import {
  amountFormat,
  amountToNumber,
  defaultGridLoading,
  isAltR,
  isCashFnKey,
  isCheckFnKey,
  isCreditFnKey,
  isEmptyObject,
  isFnNineKey,
  isFnTenKey,
  isInsert,
  manageGridLoading,
} from '../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../util/workstation-util';
import PayrixPaymentDialog from '../../common/PayrixPaymentDialog.vue';
import Forte2PaymentDialog from '../../common/Forte2PaymentDialog.vue';
import UploadFile from '../../common/UploadFile.vue';
import CommonPopUp from '../common-utils/CommonPopUp.vue';
import { getPreviousPenaltyPeriodEnd, isSameDate } from '../common-utils/CommonTaxFunctionalities';
import { parseLocalDate, payDateBeforePostingPeriodMsg, useAbortController } from '../common-utils/tax-common.util';
import CommonDecalDialog from './paymenteditDialog/commonDecalDialog.vue';
import { clients } from '../../../util/clients';

const { backendRest } = clients.direct;
const bc = new BroadcastChannel('payment_reload_channel');
bc.onmessage = (event) => {
  if (event.data === 'reload') {
    const currentPath = router.currentRoute.fullPath;
    // check for path also or else it will reload all the pages
    if (currentPath.includes('payments')) window.location.reload();
    bc.close();
  }
};

export default {
  mixins: [PaymentCommonFunc],
  data() {
    return {
      headers: paymentTransactionListHeaders,
      baseCrudKey: 'paymentTransactionList',
      baseCrudKeyForTax: 'paymentTaxTransactionList',
      gridLoading: defaultGridLoading(),
      activeTransItem: null,
      // Snapshot of the CC payment item captured when the Payrix dialog opens, so the
      // success watcher can still save the record if the live CRUD item is cleared
      // before it fires (Suspect A). Cleared after a successful save.
      ccPaymentItemSnapshot: null,
      abortController: useAbortController(),
      icons: {
        mdiCircleSlice8,
      },
      attachmentConstants: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileParams: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileClickParams: {
        leftClickFlag: false,
        leftClickDef: undefined,
        rightClickFlag: false,
        rightClickDef: undefined,
      },
      enableUploadFile: false,
      popUpMtgCodeRemoveOrNot: false,
      showOrHideLatestPostDate: false,
      showOrHideWkstErrorMsg: false,
      showOrHideFutureBusinessDate: false,
      // why the new payment was refused, when it is more specific than 'outside the posting period'
      businessDateBlockMsg: '',
      mtgCodeItems: [],
      showPaymentDetails: true,
      showLargeTransactionWarning: false,
    };
  },
  components: {
    PaymentCriteria,
    CRUDList,
    PaymentDetailsTransactionList,
    PaymentButtons,
    paymentDialog,
    auditRecord,
    CRUDDialog,
    AuditDialog,
    UploadFile,
    CommonPopUp,
    PayrixPaymentDialog,
    Forte2PaymentDialog,
    CommonDecalDialog,
  },
  created() {
    this.initCriteria();
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleSelShortCut);
  },
  computed: {
    ...mapGetters('base/crud', {
      criteria: 'criteria',
      item: 'item',
      index: 'index',
      items: 'items',
      highlightedId: 'highlightedId',
      crudIsVisible: 'isVisible',
    }),
    ...mapGetters(['todaysDate']),
    // Falls back to today when the criteria bar's "Business Date for payment entry" has never
    // been keyed this session. See effectiveBusinessDate below for why that fallback matters.
    ...mapGetters('tax/taxPayment', ['getPaymentDialogBusinessDate']),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
      isVisible: (state) => state.base.crud.isVisible.paymentTransactionList,
      isValidFormProp: (state) => state.base.crud.isValidFormProp.paymentTransactionList,
      paymentShotCutStore: (state) => state.tax.taxPayment.paymentShotCutStore,
      overPayItemsList: (state) => state.tax.taxPayment.overPayItemsList || [],
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      paymentDialogBusinessDate: (state) => state.tax.taxPayment.paymentDialogBusinessDate || '',
      isPayrixDialogOpen: (state) => state.common.payrixPayment.isDialogOpen,
      isForte2DialogOpen: (state) => state.common.forte2Payment.isDialogOpen,
      forte2SuccessFlag: (state) => state.common.forte2Payment.paymentSuccessFlag,
      forte2ActiveItemIndex: (state) => state.common.forte2Payment.activeItemIndex,
      payrixSuccessFlag: (state) => state.common.payrixPayment.paymentSuccessFlag,
      activeItemIndex: (state) => state.common.payrixPayment.activeItemIndex,
      fortePaymentSuscessFlag: (state) => state.ForteService.fortePaymentSuscessFlag,
      forteIndex: (state) => state.ForteService.forteIndex,
      payrixPaymentType: (state) => state.common.payrixPayment.payrixPaymentType,
      forte2PaymentType: (state) => state.common.forte2Payment.forte2PaymentType,
      paymentsFilterDate: (state) => state.tax.taxPayment.paymentsFilterDate || '',
    }),
    /**
     * The date a NEW payment opens on.
     *
     * tax/taxPayment.paymentDialogBusinessDate starts as '' and is only ever written by the
     * criteria bar's "Business Date for payment entry" control, which itself renders blank on
     * every page load - saving that date puts it in global config / localStorage, not back into
     * this state. So a clerk who opened Payments and pressed Insert without first keying that
     * box got `payDate: toShortDate('')` === '' on the new payment; the header's Business Date
     * came up empty, upsertNOverPaymentsCommon turned '' into null, and the payment saved with
     * no date at all (Delaware FY2027 #1699, 10/13/2026).
     *
     * getPaymentDialogBusinessDate is the store getter that falls back to today - the same one
     * the Tax Inquiry payment dialog (CommonPaymentDialog) has always used for this.
     */
    effectiveBusinessDate() {
      return this.paymentDialogBusinessDate || this.getPaymentDialogBusinessDate;
    },
    fieldNameListsForForte2Dialog() {
      if (this.forte2PaymentType === 'CREDIT') {
        return [
          'Total Due',
          'Convenience fee (credit)',
          'Convenience fee (debit)',
        ];
      } if (this.forte2PaymentType === 'ECHECK') {
        // Forte2 eCheck (loc_419531) charges no fee, so there is no fee row to label.
        return [
          'Amount Due',
        ];
      }
      return [];
    },
    fieldNameListsForPayrixDialog() {
      if (this.payrixPaymentType === 'CREDIT') {
        return [
          'Amount Due',
          'Convenience fee (credit)',
          'Convenience fee (debit)',
        ];
      } if (this.payrixPaymentType === 'ECHECK') {
        return [
          'Amount Due',
          'eCheck Fee',
        ];
      }
      return [];
    },
    // rowItem: {
    //   get() {
    //     return this.item(this.baseCrudKey);
    //   },
    //   set(value) {
    //     this.setItem([this.baseCrudKey, value]);
    //   },
    // },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    checkccProcessed() {
      const getCcProcessed = (this.editedItem.paymentDetails || []).filter((ft) => !!ft.ccProcessed);
      if (getCcProcessed.length) return false;
      return true;
    },
    onPaymentFilterChangeDate: {
      get() {
        return this.paymentsFilterDate;
      },
      set(value) {
        this.setPaymentsFilterDate(value);
      },
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    defaultSortBy() {
      return [
        {
          column: 'payDate',
          direction: 'desc',
        },
        {
          column: 'paymentNumber',
          direction: 'asc',
        },
      ];
    },
    totals() {
      const itemsDetails = this.items(this.baseCrudKey);
      const totalFields = {
        total: 0,
        checkAmt: 0,
        cashAmt: 0,
        changeAmt: 0,
        otherAmt: 0,
      };

      itemsDetails.forEach((item) => {
        totalFields.total += amountToNumber(item.total || 0);
        totalFields.checkAmt += amountToNumber(item.checkAmount || 0);
        totalFields.cashAmt += amountToNumber(item.cashAmount || 0);
        totalFields.changeAmt += amountToNumber(item.cashChange || 0);
        totalFields.otherAmt += amountToNumber(item.otherAmount || 0);
      });

      return {
        total: amountFormat(totalFields.total),
        checkAmt: amountFormat(totalFields.checkAmt),
        cashAmt: amountFormat(totalFields.cashAmt),
        changeAmt: amountFormat(totalFields.changeAmt),
        otherAmt: amountFormat(totalFields.otherAmt),
      };
    },
    isPaymentDialogOpen() {
      return this.crudIsVisible(this.baseCrudKey);
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId', 'setIndex', 'setCriteria']),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('tax/ccPayments', [
      'loadCCPaymentsTrans',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setHalfOrPostmark',
      'setPaymentShotCutStore',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadPayment',
      'upsertTaxPaymentAudit',
      'upsertTaxPaymentAudits',
      'prePostErrorCheckPayments',
      'postPayments',
    ]),
    ...mapActions('common/payrixPayment', [
      'setPaymentSuccessFlag',
      'setLastSavedPaymentItem',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setMinimizeTRToggleApiCalls',
      'setPaymentDialogBusinessDate',
      'setPaymentsFilterDate',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapActions('tax/taxInquires', [
      'removeMtgCodesFromTaxInquiry',
    ]),
    ...mapActions(['custumColrFlashMsg']),
    setPaymentsFilterDateFunc(bussDate = toShortDate()) {
      const payementFilterDate = this.onPaymentFilterChangeDate || '';
      this.criteriaState.payDate = null;
      this.criteriaState.postingPayDate = null;
      // derive Fiscal Year from the Business Date for payment entry (not today's date)
      const fiscalYear = toFiscalYear(new Date(bussDate));
      if (!payementFilterDate) {
        this.onPaymentFilterChangeDate = bussDate;
        // update the criteria state with the new buss date
        this.setCriteria([this.baseCrudKey,
          {
            ...this.criteriaState, fiscalYear, payDate: bussDate, postingPayDate: bussDate,
          }]);
      } else {
        this.setCriteria([this.baseCrudKey,
          {
            ...this.criteriaState,
            fiscalYear,
            payDate: toShortDate(payementFilterDate),
            postingPayDate: payementFilterDate,
          }]);
      }
      this.setPaymentDialogBusinessDate(bussDate);
      this.handleLoadTaxPayments();
    },
    async taxPaymentReceipt() {
      const params = { paymentNo: this.editedItem.paymentNumber };
      // Payment numbers restart every fiscal year, so paymentNo on its own also matches a prior
      // year's CC record and the receipt printed that stranger's payment as a second page
      // (Logan, Aug 2026). Scope the lookup to the fiscal year of the payment on screen -- a
      // full-year window, so an old receipt stays reprintable at any time.
      const { fiscalYear, payDate } = this.editedItem;
      const fyRange = toFiscalYearDateRange(
        fiscalYear || (payDate ? toFiscalYear(new Date(payDate)) : null),
      );
      if (fyRange) {
        params.paymentDateFrom = fyRange.from;
        params.paymentDateTo = fyRange.to;
      }
      const result = await this.loadCCPaymentsTrans({
        criteria: params,
      });

      // A payment split across several cards saves one CC record per charged card, so send
      // them all: the receipt gets a full page per card instead of only the first card's.
      // Records with no tax details can't be rendered and would 400 the whole document.
      const ccRecords = (result || []).filter((rec) => (rec.taxDetails || []).length);
      if (!ccRecords.length) {
        this.custumColrFlashMsg({ msg: 'No CC records found with the payment #' });
        return;
      }
      const payments = ccRecords.map((item) => ({
        processedPayment: {
          transactionId: item.transactionId,
          cardType: item.specialPaymentType,
          cardholderName: item.paidBy,
          paidAmt: item.amountPaid,
          processingFee: item.processingFee || 0,
          taxPayerEmail: '',
        },
        taxDetails: item.taxDetails,
        paymentMethod: item.paymentType,
      }));
      const receiptResponse = await backendRest.post('/tax/ccPayments/forte/taxpayer-receipt', { payments },
        { responseType: 'blob' });
      const blob = new Blob([receiptResponse.data], { type: 'application/pdf' });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    },
    initCriteria() {
      this.loadConfig({ requiredScope: 'taxConfig' });
      this.loadConfig({ requiredScope: 'global' });
      this.criteriaState = {};
      // const todaysDate = localStorage.getItem('tax_payment_filter_date') || '';
      // if (!todaysDate) {
      //   localStorage.setItem('tax_payment_filter_date', toShortDate());
      //   this.criteriaState.payDate = toShortDate();
      // } else this.criteriaState.payDate = toShortDate(todaysDate);
      // this.criteriaState.postingPayDate = todaysDate;
      this.criteriaState.fiscalYear = toFiscalYear(new Date(this.todaysDate));

      this.loadConfig({ requiredScope: 'paymentConfig' }).then(() => {
        const bussDateChangeIndividually = this.paymentSettingItem.changeBussDateIndividually;
        if (!bussDateChangeIndividually) {
          const bussDate = this.globalSettingItem.businessDate
            ? toShortDate(this.globalSettingItem.businessDate) : toShortDate();
          this.setPaymentsFilterDateFunc(bussDate);
        } else {
          const localBussDate = getBusinessDateForPaymentEntry();
          const bussDate = localBussDate ? toShortDate(localBussDate) : toShortDate();
          this.setPaymentsFilterDateFunc(bussDate);
        }
      }).catch((err) => console.error(err));
      window.addEventListener('keydown', this.handleSelShortCut);
    },
    async applySuccessfulPayment() {
      let savedItem = this.item(this.baseCrudKey);
      const hasDetails = (it) => !!(it && Array.isArray(it.paymentDetails) && it.paymentDetails.length);
      // Suspect A: the watcher can fire after the live CRUD item has been cleared.
      // Restore it from the snapshot taken when the Payrix dialog opened, so the entire
      // save chain has the data and the record is still created instead of silently lost.
      const restoredFromSnapshot = !hasDetails(savedItem) && hasDetails(this.ccPaymentItemSnapshot);
      if (restoredFromSnapshot) {
        savedItem = JSON.parse(JSON.stringify(this.ccPaymentItemSnapshot));
        this.setItem([this.baseCrudKey, savedItem]);
      }
      if (!hasDetails(savedItem)) {
        // No data anywhere — never fail silently: warn the clerk and reset the flag.
        this.$store.dispatch('flashError', 'The card was charged but the payment could not be saved automatically. Please contact support before re-running.');
        this.ccPaymentItemSnapshot = null;
        this.setPaymentSuccessFlag({ flag: false, transactionId: '' });
        return;
      }
      const updatedPaymentDetails = savedItem.paymentDetails.map((paymentDetail, index) => {
        const item = { ...paymentDetail };
        if (item.paymentType === 'CREDIT' && this.activeItemIndex === index) {
          item.ccProcessed = true;
        }
        return item;
      });
      const updatedItem = {
        ...savedItem,
        paymentDetails: updatedPaymentDetails,
      };
      // Set lastSavedPaymentItem BEFORE the upsert so it's available when needed
      try {
        await this.$store.dispatch('common/payrixPayment/setLastSavedPaymentItem', updatedItem);
      } catch (validationError) {
        console.error('Failed to prepare CC payment data:', validationError);
        const errorMsg = 'Credit card payment was processed but payment data is incomplete. '
          + 'Please check the console for details and contact support.';
        this.$store.dispatch('flashError', errorMsg);
        // Reset the success flag to prevent retry loops
        this.setPaymentSuccessFlag({ flag: false, transactionId: '' });
        return;
      }
      // Await the transaction to ensure proper execution order
      await this.preUpsertTransaction(updatedItem, true, false);
      // Snapshot consumed by a successful save — clear so it can't leak forward.
      this.ccPaymentItemSnapshot = null;
    },
    handleLoadTaxPayments(fromWhere) {
      manageGridLoading(this, true, 'Searching...');
      this.abortController.abort(); // abort previous fetch here
      this.abortController = useAbortController(); // reinitializing the abourtcontroller
      const { signal } = this.abortController;
      const { baseCrudKey } = this;
      const schoolDistrict = this.criteriaState.taxDistrict;
      this.criteriaState.schoolDistrict = schoolDistrict;
      const convertToIsoPayDate = this.criteriaState.payDate
        ? toIsoDate(this.criteriaState.payDate) : null;
      const convertToIsoFromDate = this.criteriaState.fromDate
        ? toIsoDate(this.criteriaState.fromDate) : null;
      const convertToIsoToDate = this.criteriaState.toDate
        ? toIsoDate(this.criteriaState.toDate) : null;

      const criteria = {
        ...this.criteriaState,

        payDate: convertToIsoPayDate,
        fromDate: convertToIsoFromDate,
        toDate: convertToIsoToDate,
      };
      delete criteria.taxDistrict;
      delete criteria.workstation;
      delete criteria.postingPayDate;
      delete criteria.overrideWkst;
      this.loadPayment({
        criteria,
        baseCrudKey,
        postProcessTrans: this.postProccessData,
        signal,
      })
        .then((val) => {
          this.setDefaultSelectedItems();
          this.setItems([this.baseCrudKeyForTax, []]);
          if (!this.isPaymentDialogOpen) {
            this.setItem([this.baseCrudKey, {}]);
          }
          // when they search by payment number upadate criteria paydata and
          // criteriaWkst with the searched record
          if (fromWhere === 'paymentNumber' && (val || []).length) {
            this.criteriaState.payDate = toShortDate(val[0].payDate);
            this.criteriaState.criteriaWkst = [val[0].workstation];
          }
          // on load this will get to the last records in the crud-list
          if ((val || []).length) {
            const clickedClassname = document.getElementsByClassName('tr-last-index')[0];
            clickedClassname.scrollIntoView({ block: 'center' });
          }
        })
        .finally(() => {
          manageGridLoading(this, false);
        });
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
      });
    },
    handleDialogItem() {
      const selectedItem = this.items(this.baseCrudKey)
        .find((item) => item._id === this.highlightedId(this.baseCrudKey));
      this.$refs.crudList.handleEditItem(selectedItem);
    },
    handlePrePaymentDialog() {
    // for overriding wkst
      const { overrideWkst, criteriaWkst } = this.criteriaState;
      if (overrideWkst) {
        if ((criteriaWkst || []).length) {
          if (criteriaWkst.length === 1) this.handleLatestPostDate(criteriaWkst[0]);
          else {
            this.showOrHideWkstErrorMsg = true;
          }
        } else {
          this.showOrHideWkstErrorMsg = true;
        }
      } else this.handleLatestPostDate();
    },
    handleLatestPostDate(overrideWkst) {
      const payDate = toShortDate(this.effectiveBusinessDate);
      // If a user tries to create a payment on a date that is less than or equal to the
      // 'Latest Post Date', then we need warning message
      if (this.paymentSettingItem.latestPostDate) {
        const formattedPayDate = new Date(payDate);
        const formattedLatestPostDate = new Date(this.paymentSettingItem.latestPostDate);
        formattedLatestPostDate.setDate(formattedLatestPostDate.getDate() + 1);
        if (formattedPayDate < formattedLatestPostDate) {
          this.showOrHideLatestPostDate = true;
        } else this.handletaxDetailNewItem(overrideWkst);
      } else this.handletaxDetailNewItem(overrideWkst);
    },
    handletaxDetailNewItem(overrideWkst) {
      this.setHalfOrPostmark({ res: this.halfOrPostmark.half, whichOne: 'dialogHalf' });
      this.setHalfOrPostmark({ res: this.halfOrPostmark.postmark, whichOne: 'dialogPostmark' });
      const payDate = toShortDate(this.effectiveBusinessDate);
      // the fiscal year will be based on BusinessDateForPaymentEntry
      const formatedDateForFiscalYear = payDate
        ? new Date(payDate) : new Date(this.todaysDate);
      const fiscalVal = toFiscalYear(formatedDateForFiscalYear);
      if (!isFiscalYearWithinPostingPeriod(fiscalVal)) {
        this.businessDateBlockMsg = '';
        this.showOrHideFutureBusinessDate = true;
        return;
      }
      // a date before the open posting period can never be posted (Tulsa 2023-191970)
      const closedPeriodMsg = payDateBeforePostingPeriodMsg(payDate, this.taxSettingItem);
      if (closedPeriodMsg) {
        this.businessDateBlockMsg = closedPeriodMsg;
        this.showOrHideFutureBusinessDate = true;
        return;
      }
      const prevPeriodEnd = getPreviousPenaltyPeriodEnd(
        this.todaysDate, this.taxSettingItem.penaltyDate,
      );
      const penDate = this.halfOrPostmark.postmark ? toShortDate(prevPeriodEnd) : toShortDate();
      const newItem = {
        fiscalYear: fiscalVal,
        payDate,
        penaltyDate: penDate,
        paymentNumber: null,
        workstation: Number(overrideWkst) || Number(getWorkstationNumber()) || null,
        taxDetails: [],
        paymentDetails: [],
      };
      this.$refs.crudList.handleNewItem(newItem);
      // this delay is required, because dialog needs some time to open
      setTimeout(() => {
        this.setPaymentShotCutStore({ res: this.paymentShotCutStore.isItPayRecordNCounter + 1, whichOne: 'isItPayRecordNCounter' });
      }, 50);
    },
    handleSelShortCut(e) {
      if (isAltR(e) || isFnTenKey(e)) this.$refs.payButtons.printReceiptOutsideDialogBox();
      if (isInsert(e) || isCreditFnKey(e) || isCashFnKey(e) || isCheckFnKey(e)) this.handlePrePaymentDialog();
      if (isFnNineKey(e)) {
        e.preventDefault();
        // Same as clicking the toolbar Half Pay switch: sets half and dialogHalf together.
        if (!e.repeat) this.$refs.payButtons.onChangeHalfOrPostmark(!this.halfOrPostmark.half, 'half');
      }
    },
    handleSingleOrArrowClick(fromCrud) {
      this.setMinimizeTRToggleApiCalls(null);
      // reflect the clicked row so the "Created By / Date-Time" line below the table updates
      this.activeTransItem = fromCrud;
      const fromCrudData = { ...fromCrud };
      let selectedRowData = [];
      // Both flags describe the row being clicked NOW, so clear them on every selection. The
      // >100 branch below only ever sets them, and the warning's own dismiss (x) was the single
      // thing that cleared it - so after one large payment the banner latched on and the detail
      // grid (v-if="!showLargeTransactionWarning") stayed hidden for every later row, however
      // few details it had.
      this.showLargeTransactionWarning = false;
      this.showPaymentDetails = true;
      if (fromCrudData.taxDetails && fromCrudData.taxDetails.length > 0
       && fromCrudData.taxDetails.length <= 100) {
        for (let i = 0; i < fromCrudData.taxDetails.length; i += 1) {
          fromCrudData.taxDetails[i]
            .initialPenaltyAmt = amountToNumber(fromCrudData.taxDetails[i].penaltyAmt);
          fromCrudData.taxDetails[i]
            .initialTaxAmt = amountToNumber(fromCrudData.taxDetails[i].taxAmt);
          fromCrudData.taxDetails[i].initialFees = fromCrudData.taxDetails[i].fees || [];
          fromCrudData.taxDetails[i].initialTotalFees = amountToNumber(
            fromCrudData.taxDetails[i].totalFees,
          );
          fromCrudData.taxDetails[i].tempVariableVoid = fromCrudData.taxDetails[i].void || false;
        }
        selectedRowData = [...selectedRowData, ...fromCrudData.taxDetails];
      } else if (fromCrudData.taxDetails && fromCrudData.taxDetails.length > 100) {
        this.showPaymentDetails = false;
        this.showLargeTransactionWarning = true;
        // flashWarn, not flashWarning - there is no such root action, so this threw
        // "[vuex] unknown action type" and the clerk never saw why the detail grid was empty.
        this.$store.dispatch('flashWarn', 'Unable to load transaction details on screen due to large number of transactions (over 100).');
      }
      if (fromCrudData.paymentDetails && fromCrudData.paymentDetails.length > 0) {
      // eslint-disable-next-line consistent-return
        fromCrudData.paymentDetails.forEach((el) => {
          if (el.paymentType === 'CHECK' && !fromCrudData.hasFiles) {
          // eslint-disable-next-line no-param-reassign
            el.highlightNoFiles = true;
            return el;
          }
        });
        selectedRowData = [...selectedRowData, ...fromCrudData.paymentDetails];
      }
      this.setItems([this.baseCrudKeyForTax, selectedRowData]);
    },
    onDoubleClicked(fromCrud) {
      this.setItems([this.baseCrudKeyForTax, []]);
      setTimeout(() => {
        if (!this.editedItem._id) this.editedItem = fromCrud;
      }, 200);
    },
    async onSaveClick(isItFromSaveNPrint) {
      // Ignore a re-click / double-click while the first save is still running - otherwise
      // both calls reach upsertTaxPayment with no paymentNumber and each mints its own,
      // creating two payment records for one transaction.
      if (this.isDuplicateSaveClick()) return;
      await this.preUpsertTransaction(this.item(this.baseCrudKey), true, isItFromSaveNPrint);
    },
    activateTransaction(val) {
      this.setMinimizeTRToggleApiCalls(null);
      this.activeTransItem = val;
    },
    isNextTwoDaysWeekends(date) {
      const today = new Date(date);
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const dayAfterTomorrow = new Date(today);
      dayAfterTomorrow.setDate(today.getDate() + 2);

      const isTomorrowWeekend = tomorrow.getDay() === 0 || tomorrow.getDay() === 6;
      const isDayAfterTomorrowWeekend = dayAfterTomorrow.getDay() === 0
       || dayAfterTomorrow.getDay() === 6;

      return isTomorrowWeekend && isDayAfterTomorrowWeekend;
    },
    // The two dates compared below are not keyed in the same shape: Tax Setting stores the
    // posting period as '10-31-2026' while a date control can hand back ISO, and raw
    // `new Date('2026-10-31')` is UTC midnight - the PREVIOUS day in every US timezone. That
    // one-day shift is enough to make the month-end check miss silently. Normalise both sides
    // to local midnight, the way isDateWithinPostingPeriod (the gate on this same dialog)
    // already does. Dates are cloned, never reused, since the weekend roll mutates them.
    toLocalPostingDate(value) {
      if (!value) return null;
      const date = value instanceof Date ? new Date(value.getTime()) : parseLocalDate(value);
      return date && !Number.isNaN(date.getTime()) ? date : null;
    },
    checkIsItWeekendOrNot(toDate, postingPayDate) {
    // Convert to Date object if string
      const checkToDate = this.toLocalPostingDate(toDate);
      const checkPostingPayDate = this.toLocalPostingDate(postingPayDate);
      if (!checkToDate || !checkPostingPayDate) return '';

      // Check if it's a weekend (Saturday = 6, Sunday = 0)
      const dayOfWeek = checkToDate.getDay();
      if (dayOfWeek === 0) {
        checkPostingPayDate.setDate(checkPostingPayDate.getDate() + 2);
        return checkPostingPayDate;
      } if (dayOfWeek === 6) {
        checkPostingPayDate.setDate(checkPostingPayDate.getDate() + 1);
        return checkPostingPayDate;
      }
      return '';
    },
    // A popup blocker turns window.open into a silent no-op, which looks exactly like the
    // month-end check never running - navigate this tab instead so the county still lands
    // on Posting Period.
    openPostingPeriodScreen() {
      const target = { name: 'Tax - Payments - Posting Period' };
      const route = this.$router.resolve(target);
      if (window.open(route.href, '_blank')) return;
      Promise.resolve(this.$router.push(target)).catch(() => {});
    },
    // the posting period only depends on the post date and the period end date,
    // so this runs whether or not anything was actually posted
    openPostingPeriodIfMonthEnd(postingPayDate) {
      const periodEndDate = this.toLocalPostingDate(this.taxSettingItem.curPostPerToDate);
      const postDate = this.toLocalPostingDate(postingPayDate);
      if (!periodEndDate || !postDate) return;
      const isItSameDate = isSameDate(periodEndDate, postDate);
      if (isItSameDate) {
        this.openPostingPeriodScreen();
      } else {
      // if the curPostPerToDate falls in the weekend, then we need to check if the
      // postingPayDate falls in the same weekend
        const isItWeekendOrNot = this.checkIsItWeekendOrNot(periodEndDate, postDate);
        if (isItWeekendOrNot) {
          const isItSameDateCompare = isSameDate(periodEndDate, isItWeekendOrNot);
          if (isItSameDateCompare) {
            this.openPostingPeriodScreen();
          }
        }
      }
    },
    async postPayment() {
      const { postingPayDate } = this.criteriaState;
      const overPaidTaxIdList = (this.overPayItemsList || []).map((dt) => dt.overPaidTaxId);
      const overPaidTaxYearList = (this.overPayItemsList || []).map((dt) => dt.overPaidTaxYear);
      const { baseCrudKey } = this;
      const convertToIsoPostingPayDate = postingPayDate
        ? toIsoDate(postingPayDate) : null;
      const updatedItem = {
        workstation: this.criteriaState.workstation || [],
        payDate: convertToIsoPostingPayDate,
        overPaidTaxIdList,
        overPaidTaxYearList,
      };
      const retItems = await this.postPayments({
        item: updatedItem,
        baseCrudKey,
      });

      // if the posting is successful, then we need to check the below conditions
      if (retItems.statusCode === 200) {
        this.$refs.paymentCriteria.closePostDialog(retItems);
        this.handleLoadTaxPayments();
        this.openPostingPeriodIfMonthEnd(postingPayDate);
      } else if (retItems.statusCode === 404) {
        // no payments found to post, but the county still needs to close the month
        this.$refs.paymentCriteria.closePostDialog(retItems);
        this.openPostingPeriodIfMonthEnd(postingPayDate);
      }
    },
    async preErrorCheckPayments() {
      const { baseCrudKey } = this;
      const convertToIsoPostingPayDate = this.criteriaState.postingPayDate
        ? toIsoDate(this.criteriaState.postingPayDate) : null;
      const updatedItem = {
        workstation: this.criteriaState.workstation || [],
        payDate: convertToIsoPostingPayDate,
        flagForAuditApprovedOrNot:
        this.paymentSettingItem.auditsMustBeApprovedBeforePosting || false,
      };
      const retItems = await this.prePostErrorCheckPayments({
        item: updatedItem,
        baseCrudKey,
      });
      this.$refs.paymentCriteria.closePostDialog(retItems, 'errorCheckPayments');
    },
    async openPopUpForMtgCodeRemoveOrNot(whatIsIt) {
      if (whatIsIt === 'Remove') {
        const item = this.mtgCodeItems;
        await this.removeMtgCodesFromTaxInquiry({ item });
        this.popUpMtgCodeRemoveOrNot = false;
        this.mtgCodeItems = [];
      } else {
        this.popUpMtgCodeRemoveOrNot = false;
        this.mtgCodeItems = [];
      }
    },
    crudDialogClose() {
      const isThereNewRecords = (this.editedItem.taxDetails || []).filter((dt) => dt.itsNewRecord);
      if ((isThereNewRecords || []).length) {
        if (window.confirm('There are some unsaved records, are you sure you want to close?')) {
          this.onPaymentDialogClose();
        }
      } else this.onPaymentDialogClose();
    },
    getMtgCodesMsg() {
      const mtgArr = (this.mtgCodeItems || []).map((dt) => dt.mtgCode);
      const mtgMsg = `Would you like to remove mortgage code ${(mtgArr || []).toString()} from this record?`;
      return mtgMsg;
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
        await this.preUpsertTransaction(this.item(this.baseCrudKey), true, false, false);
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
        await this.preUpsertTransaction(this.item(this.baseCrudKey), true, false, false);
      } else {
        rightClick();
      }
    },
    settingFields(res) {
      this.activeTransItem = res;
      this.setItem([this.baseCrudKey, res]);
      this.setIndex([this.baseCrudKey, 0]);
    },
    updateActiveTransItem(res) {
      if (this.uploadFileClickParams.leftClickFlag) {
        this.settingFields(res);
        // this.$refs.crudList.$refs.crudDialog.apply();
        this.$nextTick(() => {
          this.imagesLeftClick(this.uploadFileClickParams.leftClickDef);
          this.uploadFileClickParams.leftClickFlag = false;
          this.uploadFileClickParams.leftClickDef = undefined;
        });
      } else if (this.uploadFileClickParams.rightClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesRightClick(this.uploadFileClickParams.rightClickDef);
          this.uploadFileClickParams.rightClickFlag = false;
          this.uploadFileClickParams.rightClickDef = undefined;
        });
      }
      return false;
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.editedItem._id || 'n/a',
      });
    },
    /**
     * Is this payment's Business Date usable? Checked on every save path, including the
     * credit-card success watchers.
     *
     * The dialog's own Save / Save & print buttons never run the CRUD dialog's validateForm(),
     * and the form is :lazy-validation="true" - a field the clerk never focused is not in the
     * form's error bag at all, so isValidFormProp stays TRUE for a Business Date that was blank
     * from the moment the dialog opened. That is exactly how Delaware FY2027 #1699 saved with no
     * date: the Required rule on the field existed, it was simply never run. This is the check
     * that does not depend on the field having been touched.
     */
    /**
     * Runs the dialog form's own rules so the red messages appear. The dialog's Save buttons
     * live in CRUDDialog's additionalActionsAfterSave slot and call onSaveClick directly, so
     * CRUDDialog.save() - the only thing that calls validateForm() - is bypassed on every
     * normal save. Guarded: the refs are absent when the dialog is not open (the CC success
     * watchers can save with it closed).
     */
    validatePaymentForm() {
      const dialog = this.$refs.crudList && this.$refs.crudList.$refs.crudDialog;
      if (dialog && typeof dialog.validateForm === 'function') dialog.validateForm();
    },
    hasUsableBusinessDate(item) {
      const payDate = item && item.payDate;
      if (!payDate) return false;
      const asDate = payDate instanceof Date ? payDate : new Date(toIsoDate(payDate));
      return !Number.isNaN(asDate.getTime());
    },
    // eslint-disable-next-line max-len
    async preUpsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog = true) {
      if (!this.hasUsableBusinessDate(item)) {
        // Show the red Required under the field as well as saying why nothing saved - a save
        // that silently does nothing is what let the clerk carry on and lose the date.
        this.validatePaymentForm();
        console.warn(
          'preUpsertTransaction skipped: the payment has no usable Business Date; nothing was saved.',
          { payDate: item && item.payDate, itemId: (item && item._id) || '(new)' },
        );
        this.$store.dispatch('flashError', 'Business Date is required. Enter the Business Date on this payment and save again.');
        return;
      }
      if (this.isValidFormProp.value) {
        this.enableUploadFile = true;
        const response = await this.upsertTransaction(item, avoidUpdatingCrudList,
          isItFromSaveNPrint, shouldCloseDialog);

        this.enableUploadFile = false;

        // if the resetTheDialog is false, then we can stop the execution here
        // this will prevent the data loss in payment dialog
        if (!response.resetTheDialog) return;

        // this reload is required as we dont know if the payment has loadmore flag are not
        // if its from file upload, we dont need to reload the page
        if (shouldCloseDialog) this.handleLoadTaxPayments();
        if (this.isNewItem) {
          if (!isEmptyObject(response)) {
            this.updateActiveTransItem(response);
          }
          this.setDefaultSelectedItems();
        }
      } else {
        // A CC charge may already have completed when this runs (applySuccessfulPayment
        // calls it too), so a skip here can mean silent data loss — log it so the cause
        // is visible in console/HAR captures. undefined means the form validity state
        // was never initialized, false means a field is actually invalid.
        console.warn(
          'preUpsertTransaction skipped: payment form is not valid; nothing was saved.',
          { isValidFormProp: this.isValidFormProp.value, itemId: (item && item._id) || '(new)' },
        );
        // Say so on screen as well. A Save that does nothing and reports nothing is how a
        // clerk comes away believing the payment was recorded.
        this.validatePaymentForm();
        this.$store.dispatch('flashError', 'This payment has a field that needs fixing - nothing was saved. Check the fields marked in red.');
      }
    },
    openConfirmWkstErrorPopUp(cancleOrContinue) {
      if (cancleOrContinue === 'OK') {
        this.showOrHideWkstErrorMsg = false;
      }
    },
    openConfirmPopUp(cancleOrContinue) {
      if (cancleOrContinue === 'Cancel') {
        this.showOrHideLatestPostDate = false;
        this.setIsVisible([this.baseCrudKey, false]);
      } else {
        this.showOrHideLatestPostDate = false;
        const { overrideWkst, criteriaWkst } = this.criteriaState;
        if (overrideWkst && (criteriaWkst || []).length) {
          if (criteriaWkst.length === 1) this.handletaxDetailNewItem(criteriaWkst[0]);
        } else this.handletaxDetailNewItem();
      }
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        window.removeEventListener('keydown', this.handleSelShortCut);
        this.loadFiles();
      } else window.addEventListener('keydown', this.handleSelShortCut);
    },
    isPayrixDialogOpen(isOpen) {
      // Capture the payment item while the Payrix dialog is open (guaranteed present
      // here). If the live CRUD item is cleared before payrixSuccessFlag fires,
      // applySuccessfulPayment rebuilds the save from this snapshot (Suspect A).
      if (isOpen) {
        const item = this.item(this.baseCrudKey);
        if (item && Array.isArray(item.paymentDetails) && item.paymentDetails.length) {
          this.ccPaymentItemSnapshot = JSON.parse(JSON.stringify(item));
        }
      }
    },
    async payrixSuccessFlag(newVal) {
      if (newVal) {
        // The charge already succeeded — await so a rejection is actually caught
        // (a non-awaited promise rejection bypasses try/catch) and so the save's
        // async steps complete in order. Never let a failure vanish silently.
        try {
          await this.applySuccessfulPayment();
        } catch (e) {
          console.error('applySuccessfulPayment failed:', e);
          this.$store.dispatch('flashError', 'The card was charged but saving the payment failed unexpectedly. Please contact support before re-running.');
          // Clear the snapshot so a later flag flip can't silently re-save stale data.
          this.ccPaymentItemSnapshot = null;
          this.setPaymentSuccessFlag({ flag: false, transactionId: '' });
        }
      }
    },
    fortePaymentSuscessFlag(newVal) {
      // pay Now part
      if (newVal) {
        const savedItem = this.item(this.baseCrudKey);
        const updatedPaymentDetails = savedItem.paymentDetails.map((paymentDetail, index) => {
          const item = { ...paymentDetail };
          if (index === this.forteIndex && item.paymentType === 'CREDIT') {
            item.ccProcessed = true;
          }
          return item;
        });
        const updatedItem = {
          ...savedItem,
          paymentDetails: updatedPaymentDetails,
        };
        this.preUpsertTransaction(updatedItem, true, false);
        // this.$refs.crudList.$refs.crudDialog.apply();
      }
    },
    async forte2SuccessFlag(newVal) {
      if (newVal) {
        const savedItem = this.item(this.baseCrudKey);
        // The crud `item` getter defaults to {} (empty initial state), and this watcher fires for
        // every mounted instance on the global success flag — so an instance whose row is empty
        // would hit `undefined.map` and drop a completed charge's record. Guard before mapping.
        if (!savedItem || !Array.isArray(savedItem.paymentDetails)) {
          console.warn('forte2SuccessFlag: no saved item / paymentDetails to update');
          return;
        }
        const updatedPaymentDetails = savedItem.paymentDetails.map((paymentDetail, index) => {
          const item = { ...paymentDetail };
          // Match the charged row on the LIVE tender, not the 'CREDIT' literal: eCheck rows keep
          // ccProcessed through buildPaymentItem, so leaving one false makes the save's
          // unprocessed-card guard fire and a Cancel there discards the record of a completed
          // charge. Mirrors CommonPaymentDialog.vue's tender-aware watcher.
          if (index === this.forte2ActiveItemIndex && item.paymentType === this.forte2PaymentType) {
            item.ccProcessed = true;
          }
          return item;
        });
        const updatedItem = {
          ...savedItem,
          paymentDetails: updatedPaymentDetails,
        };
        await this.preUpsertTransaction(updatedItem, true, false);
      }
    },
  },
};
</script>
<style scoped>
.custom-margin {
  padding-left: 0;
  margin-left: 0;
}
</style>
